







































import { Validator } from 'vee-validate'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Inject, Prop } from 'vue-property-decorator'

import DateSelect from '@spa/components/organisms/birthday/DateDropdownSelect.vue'
import MonthSelect from '@spa/components/organisms/birthday/MonthDropdownSelect.vue'
import YearSelect from '@spa/components/organisms/birthday/YearDropdownSelect.vue'
import { PluginMixin } from '@spa/mixins/plugin'
import { BirthdayFormState } from './birthdayFormState'

@Component({
  components: {
    YearSelect,
    MonthSelect,
    DateSelect,
  },
})
export default class BirthdayForm extends Mixins<PluginMixin>(PluginMixin) {
  @Inject()
  $validator: Validator

  @Prop({ default: null })
  year: number | null

  @Prop({ default: null })
  month: number | null

  @Prop({ default: null })
  day: number | null

  @Prop({ default: false })
  disabled: boolean

  @Prop({ required: true })
  handleFormUpdated: (val: BirthdayFormState) => void

  get formState(): BirthdayFormState {
    return {
      year: this.year,
      month: this.month,
      day: this.day,
    }
  }

  get hasExtendedValidationError(): boolean {
    return !!this.$slots.extendedValidationErrorMessage
  }

  handleInputYear(input: string): void {
    this.handleFormUpdated({
      ...this.formState,
      year: Number(input),
    })
  }

  handleInputMonth(input: string): void {
    this.handleFormUpdated({
      ...this.formState,
      month: Number(input),
    })
  }

  handleInputDay(input: string): void {
    this.handleFormUpdated({
      ...this.formState,
      day: Number(input),
    })
  }
}
